import { render, staticRenderFns } from "./HistoryExam.vue?vue&type=template&id=134ccf39&scoped=true&"
import script from "./HistoryExam.vue?vue&type=script&lang=js&"
export * from "./HistoryExam.vue?vue&type=script&lang=js&"
import style0 from "./HistoryExam.vue?vue&type=style&index=0&id=134ccf39&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ccf39",
  null
  
)

export default component.exports